<template lang="pug">
    .re-cart-billing(:class="getComponentClasses()")
        re-group-box.container-form-billing.billing-content(v-if="cardRegistrations !== null")
            template(v-if="showBillingForm")
                .re-group-box-title-container
                    h3 {{ title }}

                #total-processing-form-container(v-once)
                    form(:action="shopperResultUrl" class="paymentWidgets" data-brands="VISA MASTER")

            template(v-else)
                .re-group-box-title-container
                    h3 Payment
                    .add-new-card(@click="addNewCard")
                        img(src="/images/client/got-me-hookd/cart-add-card.svg" alt="")
                        span Add New Card
                payment-methods(:card-registrations="cardRegistrations" :start="cardRegistrationIndex" @select="cardRegistrationIndex = $event")

            .re-group-box.total
                .total-label Total:
                .total-value {{ costDetails.total | currency }}

            .message-container
                component(
                    :is="errorComponent"
                    :error="validationError"
                    v-if="showErrorMessage"
                    errorContainerClass="submit-payment-error")

            .billing-button-container(v-if="!isFormDisabled")
                re-button.re-button--sm.re-button--secondary(v-if="addingNewCard" @click="addingNewCard = false") Cancel
                re-button.re-button--sm.re-button--secondary(v-else @click="clearCartItems") Clear Cart
                re-button.re-button--sm.re-button--primary(v-if="!showBillingForm" @click="submit" :loading="isSubmitting")
                    span {{ submitButtonTitle }} 

        .re-loading(v-show="isValidatingCart || isSubmitting")
            static-loader-control

</template>

<script>
import ReCartBilling from 'utils/vue/components/complex/cart/general/re-cart-billing/script.js'
import { EventBus } from 'utils/vue/components/complex/cart/general/re-cart-billing/config.js'
import PaymentMethods from './payment-methods'

export default {
    name: 'gmh-cart-billing',

    mixins: [
        ReCartBilling,
    ],

    components: {
        PaymentMethods
    },

    props: {
        expDateLabel: {
            type: String,
            default() {
                return this.$options.$$t('form.fields.expDate.label', 'Expiration Date')
            }
        },
    },

    data() { return {
        cardRegistrations: null,
        cardRegistrationIndex: 0,
        addingNewCard: false,
        saveCard: true,

        totalProcessingMounting: false,
        checkoutId: null,
        shopperResultUrl: null,
        paymentId: null,
        cardBrand: null,
    }},

    computed: {
        showBillingFormCancelButton() {
            return this.cardRegistrations.length > 0
        },
        showBillingForm() {
            return this.cardRegistrations.length == 0 || this.addingNewCard
        },
        paymentMethod() {
            return 
        }
    },

    async created() {
        if (this.$route.query.id) {
            const id = this.$route.query.id

            this.$router.replace({ 'query': null })

            const { data } = await axios.get(`/api/customer/total-processing/checkout/${id}/payment`)

            if (data.id) {
                this.paymentId = data.id
                this.cardBrand = data.payment_brand

                const nameParts = data.card.holder.split(' ', 2)
                this.fields.first_name = nameParts[0] || ''
                this.fields.last_name = nameParts[1] || ''

                this.fields.card = data.card.bin + '000000' + data.card.last4Digits
                this.fields.cvv = '000'
                this.fields.expMonth = data.card.expiryMonth
                this.fields.expYear = data.card.expiryYear

                try {
                    await this.submit()
                } finally {
                    if (this.cartStep === 'final') {
                        return
                    }
                }
            } else {
                this.setValidationError(data.error)
                this.setCartInvalid()
            }
        }

        const currentUrl = new URL(window.location.href)
        this.shopperResultUrl = currentUrl.origin + currentUrl.pathname

        const { data: { data: cardRegistrations } } = await axios.get('/api/customer/total-processing/card-registration')
        const primaryCardRegistrationId = this.$store.getters.authUser.primary_card_registration_id
        const cardRegistrationIndex = cardRegistrations.map(x => x.id).indexOf(primaryCardRegistrationId)
        this.cardRegistrationIndex = cardRegistrationIndex < 0 ? 0 : cardRegistrationIndex
        this.cardRegistrations = cardRegistrations
    },

    updated() {
        if (this.costDetails.total && !this.totalProcessingMounting && !this.checkoutId && document.getElementById('total-processing-form-container')) {
            this.mountTotalProcessing()
        }
    },

    methods: {
        async mountTotalProcessing() {
            this.totalProcessingMounting = true

            const { data } = await axios.post('/api/customer/total-processing/checkout', {
                amount: this.costDetails.total,
            })
            this.checkoutId = data.id

            const wpwlOptionsText = `
                var wpwlOptions = {
                    onReady: function() {
                        var saveCardHtml =
                            '<div class="wpwl-wrapper wpwl-wrapper-custom">' +
                            '<label for="saveCardCheckbox">' +
                            '<input id="saveCardCheckbox" type="checkbox" name="customParameters[SHOPPER_saveCard]" value="true" />' +
                            'Save this card for quicker checkout on future purchases.' +
                            '</label>' +
                            '</div>';
                        $('form.wpwl-form-card').find('.wpwl-button').before(saveCardHtml);
                    },
                    brandDetection: true,
                    brandDetectionType: 'binlist',
                    maskCvv: true,
                }`

            const wpwlOptionsScript = document.createElement('script')
            wpwlOptionsScript.appendChild(document.createTextNode(wpwlOptionsText))
            document.head.appendChild(wpwlOptionsScript)

            const paymentWidgetsScript = document.createElement('script')
            paymentWidgetsScript.setAttribute('src', data.payment_widgets_js_url)
            document.head.appendChild(paymentWidgetsScript)
        },

        addNewCard() {
            this.checkoutId = null
            this.addingNewCard = true
        },

        async submit() {
            const cardExtra = {}
            let cardBrand = null;
            if (this.paymentId) {
                cardExtra.payment_id = this.paymentId
                cardBrand = this.cardBrand
            } else {
                const cardRegistration = this.cardRegistrations[this.cardRegistrationIndex]

                const nameParts = cardRegistration.card_holder.split(' ', 2)
                this.fields.first_name = nameParts[0] || ''
                this.fields.last_name = nameParts[1] || ''

                this.fields.card = '000000000000' + cardRegistration.card_last4
                this.fields.cvv = '000'
                this.fields.expMonth = cardRegistration.card_expiry_month
                this.fields.expYear = cardRegistration.card_expiry_year

                cardExtra.card_registration_id = cardRegistration.id

                cardBrand = cardRegistration.card_brand
            }

            this.fields.billingEnabled = true // this.billingEnabled

            this.formSubmitting = true
            this.setValidationError()

            const payload = {
                payment: {
                    card: {
                        extra: cardExtra,
                        number: this.fields.card.replace(/ +/g, '').trim(),
                        year: this.fields.expYear,
                        month: this.fields.expMonth,
                        code: this.fields.cvv,
                        first_name: this.fields.first_name,
                        last_name: this.fields.last_name,
                        brand: cardBrand,
                    },
                    billing: {
                        first_name: this.fields.first_name,
                        last_name: this.fields.last_name,
                    }
                }
            }

            EventBus.$emit('billing.before.submit', payload)
            this.$v.$reset()
            this.setPaymentDetails(this.fields)
            await this.submitCart(payload)
        },

        cancel() {
            if (this.addingNewCard) {
                this.addingNewCard = false
            } else {
                this.clearCartItems();
            }
        },
    },
}
</script>
